<template>
    <!--
        The frameless layout: the sign-in screens. It paints NOTHING, so the page canvas the
        theme establishes on `body` (`--ui-bg-canvas`, see `theme/theme.css`) is what the
        card floats on — the same canvas the signed-in shell uses, so the two screens are
        recognisably one product.

        The height is the DYNAMIC viewport, not the static 100vh one this used to ask for: 100vh
        is the viewport a mobile browser would have with its URL bar hidden, so on a phone it is
        taller than what is actually on screen — the "centred" card sat low, below the middle,
        and the page scrolled for no reason. Same unit, same reason, as the shell (`Default.vue`).

        (The utility is named in the class below and nowhere else in this comment: Tailwind v4
        scans this file as text, so spelling the old class here would emit a rule nothing uses.)
    -->
    <div class="flex items-center justify-center min-h-dvh p-4">
        <router-view />
    </div>
</template>
